import { z } from 'zod';

export const ProdutoTipoFiscalSchema = z.object({
    prt_codigo: z.string(),
    prt_descricao: z.string(),
});

export type ProdutoTipoFiscal = z.infer<typeof ProdutoTipoFiscalSchema>;
